import { useIntl } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { Chips } from '~/eds/src/components/Chips/Chips';
import { DateText } from '~/eds/src/components/DateText/DateText';
import { Text } from '~/eds/src/components/Text/Text';

import { INFO_SPACING, INFO_WIDTH } from '../../../constants';
import { FieldValue } from '../../types';

interface Props {
  fieldValue: FieldValue;
}

export const FieldValueDisplay = ({ fieldValue }: Props) => {
  const intl = useIntl();
  const { type, value } = fieldValue;

  if (value === null) {
    return (
      <Text>
        {intl.formatMessage({
          id: 'FieldValueDisplay.noValueFound',
          defaultMessage: 'No value found',
          description: 'Message displayed when no field value is found',
        })}
      </Text>
    );
  }

  let display;
  switch (type) {
    case 'classification':
      display = (
        <Box minW={INFO_WIDTH} py={INFO_SPACING}>
          <Chips
            limit={3}
            direction="column"
            chips={(value as string[]).map((v) => ({ text: v }))}
          />
        </Box>
      );
      break;
    case 'datetime':
      display = <DateText date={new Date((value ?? '') as string)} />;
      break;
    case 'bool':
    case 'int':
    case 'float':
    case 'string':
    case 'text_area':
    default:
      display = <Text color="unset">{value}</Text>;
  }

  return display;
};
